import moment, { Moment } from 'moment';
import React from 'react';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';

export interface UnfinishedDPNFilterValues {
	createdFrom?: Moment | string;
	createdTo?: Moment | string;
	startFrom?: Moment | string;
	startTo?: Moment | string;
	expectedEndFrom?: Moment | string;
	expectedEndTo?: Moment | string;
	patientId?: string
}

interface Props {
	onFilter: (values: UnfinishedDPNFilterValues) => void;
}

const UnfinishedDPNFilter: React.FC<Props> = ({ onFilter }) => {
	const onFilterData = (values: any) => {
		const filter: UnfinishedDPNFilterValues = {
			createdFrom: values?.createdFrom ? moment(values.createdFrom).format('YYYY-MM-DD') : undefined,
			createdTo: values?.createdTo ? moment(values.createdTo).format('YYYY-MM-DD') : undefined,
			startFrom: values?.startFrom ? moment(values.startFrom).format('YYYY-MM-DD') : undefined,
			startTo: values?.startTo ? moment(values.startTo).format('YYYY-MM-DD') : undefined,
			expectedEndFrom: values?.expectedEndFrom ? moment(values.expectedEndFrom).format('YYYY-MM-DD') : undefined,
			expectedEndTo: values?.expectedEndTo ? moment(values.expectedEndTo).format('YYYY-MM-DD') : undefined,
			patientId: values?.patient?.value || undefined
		};
		onFilter(filter);
	};

	return (
		<GridFilter onChange={onFilterData}>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_BIRTH_NUMBER}
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
				customKey={'patient'}
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={230}
				enableAutocomplete
				customKey={'createdFrom'}
				customLabel={'nczi.electronicDPN.filter.createdFrom'}
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={230}
				enableAutocomplete
				customKey={'createdTo'}
				customLabel={'nczi.electronicDPN.filter.createdTo'}
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={230}
				enableAutocomplete
				customKey={'startFrom'}
				customLabel={'nczi.electronicDPN.filter.startFrom'}
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={230}
				enableAutocomplete
				customKey={'startTo'}
				customLabel={'nczi.electronicDPN.filter.startTo'}
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={260}
				enableAutocomplete
				customKey={'expectedEndFrom'}
				customLabel={'nczi.electronicDPN.filter.expectedEndFrom'}
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={260}
				enableAutocomplete
				customKey={'expectedEndTo'}
				customLabel={'nczi.electronicDPN.filter.expectedEndTo'}
			/>
		</GridFilter>
	);
};

export default UnfinishedDPNFilter;
